import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { Destination } from './destination';

// Update filters to be a string array instead of object
export type DestinationTableFilters = string[];

export enum DESTINATION_TABLE_COLUMN {
  NAME = 'name',
  STATUS = 'status',
  LAST_SYNC = 'lastSync',
  LAST_MODIFIED = 'lastModified',
}

export type DestinationTableHeader = {
  id: DESTINATION_TABLE_COLUMN;
  label: string;
};

export interface DestinationTableContextState {
  // Raw data (from Redux)
  rawDestinations: Destination[];
  loading: boolean;
  error: boolean;
  refetch: () => void;

  // Search state
  searchQuery: string;
  setSearchQuery: (query: string) => void;

  // Filter state
  filters: DestinationTableFilters;
  toggleFilter: (filterId: string) => void;
  clearFilters: () => void;

  // Sort state
  sortBy: DESTINATION_TABLE_COLUMN;
  sortDirection: SORT_DIRECTIONS;
  setSortBy: (column: DESTINATION_TABLE_COLUMN) => void;
  setSortDirection: (direction: SORT_DIRECTIONS) => void;

  // Pagination state
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;

  // Computed/Derived data (memoized)
  filteredDestinations: Destination[];
  displayedDestinations: Destination[];

  // Helper actions
  resetAllFilters: () => void;
  resetToFirstPage: () => void;
}
